const Genv = {
        title: 'OWL 360 SAS', App: "", user: 0
}
var GuserId = 0;
export {
        Genv,
        GuserId
}
